import type { QuestionResponseSchema } from "@/hera-api/client/types.gen";

/** Confirmation collected on the fees / payment step instead of the question list. */
export function isPaymentScreenAttestation(
  question: Pick<
    QuestionResponseSchema,
    "question_type" | "answer_type" | "show_on_fees_payment_screen"
  >,
): boolean {
  return (
    question.question_type === "registration" &&
    question.answer_type === "confirmation" &&
    question.show_on_fees_payment_screen === true
  );
}
